import { cn } from "@/lib/utils"

export function BrandMark({ className }: { className?: string }) {
  return (
    <svg
      viewBox="0 0 64 64"
      className={cn("brand-mark", className)}
      aria-hidden="true"
      focusable="false"
    >
      <rect className="brand-mark__ground" width="64" height="64" rx="12" />
      <path
        className="brand-mark__route"
        d="M16 13c0 8 23 4 23 14 0 9-22 6-22 17 0 9 20 5 30 8"
      />
      <circle className="brand-mark__origin" cx="16" cy="12" r="4.5" />
      <circle className="brand-mark__datum" cx="39" cy="27" r="3.5" />
      <path className="brand-mark__bearing" d="M23 36h9m-4.5-4.5v9" />
      <rect
        className="brand-mark__signal"
        x="43"
        y="48"
        width="9"
        height="9"
        rx="2"
        transform="rotate(45 47.5 52.5)"
      />
    </svg>
  )
}
